import { addTaskConstant } from 'src/redux/actions/constant';

const {
  ADD_TASK_THERAPIST_REQUEST,
  ADD_TASK_THERAPIST_SUCCESS,
  ADD_TASK_THERAPIST_FAILURE,
  ADD_TASK_THERAPIST_RESET,
  ADD_TASK_THERAPIST_LOADING,
} = addTaskConstant;

const intialState: object = {
  response: null,
  isTaskAdded: false,
  loading: false,
};

export const AddTaskToTherapistReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case ADD_TASK_THERAPIST_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isTaskAdded: true,
        loading: false,
      };
    }
    case ADD_TASK_THERAPIST_FAILURE: {
      return {
        ...state,
        response: action.payload,
        isTaskAdded: false,
        loading: false,
      };
    }

    case ADD_TASK_THERAPIST_LOADING:
      return {
        ...state,
        loading: true,
      };

    case ADD_TASK_THERAPIST_RESET:
      return {
        ...state,
        response: null,
        isTaskAdded: false,
        loading: false,
      };

    default:
      return state;
  }
};
